import {normalizeSpreadsheetCellValue} from "./shared/normalize-spreadsheet-cell-value";
import {PreventionInvalidityCode} from "../preventative-interactions";
import {BaseImportTransformer} from "./shared";

/**
 * @param {*} item
 * @returns {boolean}
 */
function isExternalVendorSeedRow(item) {
    return Boolean(normalizeSpreadsheetCellValue(item?.code));
}

/**
 * External vendors import — maps spreadsheet vendor codes to importVendorFromSpire payloads.
 */
export class ExternalVendorsImportTransformer extends BaseImportTransformer {
    async run(mappedData, isFinalRun = false) {
        const rows = mappedData ?? [];
        const preventativeIssues = [];

        /** @type {{index: number, item: *, seedValid: boolean, codes: string[]}[]} */
        const rowState = rows.map((item, index) => ({
            index,
            item,
            seedValid: isExternalVendorSeedRow(item),
            codes: [],
        }));

        for (const rs of rowState) {
            if (!rs.item) continue;
            if (!rs.seedValid) {
                rs.codes.push(PreventionInvalidityCode.MISSING_REQUIRED_FIELDS);
            }
        }

        for (const rs of rowState) {
            if (!rs.item) continue;
            if (!rs.codes.length) continue;
            preventativeIssues.push({
                rowIndex: rs.index,
                invalidityCodes: [...new Set(rs.codes)],
                originalRow: rs.item,
            });
        }

        const issueIndexSet = new Set(preventativeIssues.map((p) => p.rowIndex));

        const apiRequests = rows.map((item, index) => {
            if (!item) return null;
            const code = normalizeSpreadsheetCellValue(item.code);
            if (issueIndexSet.has(index)) {
                return isFinalRun ? null : {code};
            }
            return {code};
        });

        return {apiRequests, preventativeIssues};
    }
}
